import {entity} from "../rpc/api";
import JobCareerList = entity.JobCareerList;
import JobCareerWithCustomerID = entity.JobCareerWithCustomerID;
import {Occupation} from "../../../domain/model/project";

import {FrontDate} from "../../../domain/model/frontDate";

import {occupationsByDeprecated} from "../../../util/depricated";
import {EmploymentStatus} from "../../../domain/model/job_career";

class JobCareerConvertResponse {

    public static from(from: entity.JobCareer): JobCareerConvertResponse {

        // Backend => FrontEnd における型変換
        const startedAtDate: FrontDate = FrontDate.fromYearMonthDayNumber(from.startedAtYear, from.startedAtMonth, from.startedAtDay);
        const endedAtDate: FrontDate = FrontDate.fromYearMonthDayNumber(from.endedAtYear, from.endedAtMonth, from.endedAtDay);

        return new JobCareerConvertResponse(
            from.id,
            from.customerID,
            from.companyName,
            from.description,
            occupationsByDeprecated(from.occupations),
            startedAtDate,
            endedAtDate,
            from.post,
            from.employmentStatus
        )
    }

    constructor(public readonly id: string,
                public readonly customerID: string,
                public readonly companyName: string,
                public readonly description: string,
                public readonly occupations: Occupation[],
                public readonly startedAt: FrontDate,
                public readonly endedAt: FrontDate,
                public readonly post: string,
                public readonly employmentStatus: EmploymentStatus,

    ) {
    }

}

class JobCareerConvertResponseList {

    public static from(from: JobCareerList): JobCareerConvertResponseList {
        const items: JobCareerConvertResponse[] = [];

        from.items.map((item, index) => {
            return items.push(JobCareerConvertResponse.from(item as entity.JobCareer))
        });

        return new JobCareerConvertResponseList(
            items,
        )
    };

    constructor(
        public readonly items: JobCareerConvertResponse[],
    ) {
    };

}

class JobCareerConvertResponseListByCustomerIDs {

    public static from(from: JobCareerWithCustomerID): JobCareerConvertResponseList {
        const items: JobCareerConvertResponse[] = [];

        from.jobCareers.map((item, index) => {
            return items.push(JobCareerConvertResponse.from(item as entity.JobCareer))
        });

        return new JobCareerConvertResponseList(
            items,
        )
    };

    constructor(
        public readonly items: JobCareerConvertResponse[],
    ) {
    };

}

export {
    JobCareerConvertResponse,
    JobCareerConvertResponseList,
    JobCareerConvertResponseListByCustomerIDs,
}



// WEBPACK FOOTER //
// ./src/infra/api/service/job_career_api_convert.ts